const messages = {
    "title": "Maintenance",
    "description": "Des travaux de maintenance nécessaires sont actuellement en cours sur les serveurs.<br/><br/>Par conséquent, vous n'avez actuellement pas accès à <b>BRIDGESTONE <span class=\"text-danger\">PLUS</span></b>.<br/><br/>Nous vous prions de faire preuve de patience et vous remercions pour votre compréhension.<br/><br/>Votre équipe Bridgestone"
}
export default {
    messages
}
